var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoyaltyPointsZoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3185",
    "data-name": "Rectangle 3185",
    width: 24,
    height: 24,
    transform: "translate(46 389)",
    fill: "none",
    stroke: "#232323",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5902",
    "data-name": "Mask Group 5902",
    transform: "translate(-46 -389)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7457",
    "data-name": "Group 7457",
    transform: "translate(-1.001 -0.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vip",
    d: "M19.473,14.511l-1.974,7.6a1.03,1.03,0,0,1-.994.77h-11a1.03,1.03,0,0,1-.994-.77l-1.974-7.6A1.027,1.027,0,0,1,3.9,13.292l3.271,1.26a.166.166,0,0,0,.19-.052L10.2,10.868a1.023,1.023,0,0,1,1.62,0L14.648,14.5a.166.166,0,0,0,.19.052l3.271-1.26a1.035,1.035,0,0,1,1.363,1.219Z",
    transform: "translate(47.997 383.189)",
    fill: "none",
    stroke: "#232323",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x2: 12.751,
    transform: "translate(52.625 409.429)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeWidth: 1.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyPointsZoneIcon);
export default __webpack_public_path__ + "static/media/LoyaltyPointsZoneIcon.06ec120e347df1024ee540d71a411666.svg";
export { ForwardRef as ReactComponent };